import {Gender} from '@/domain/models/Gender';

const genderContext: Readonly<{[gender in Gender]: string}> = {
  F: 'female',
  M: 'male',
  NB: 'nonBinary',
  TF: 'female',
  TM: 'male',
};

const genderTransContext: Readonly<{[gender in Gender]: string}> = {
  ...genderContext,
  TF: 'transFemale',
  TM: 'transMale',
};

export function getGenderContext(gender: Gender, asTrans: boolean = false) {
  return asTrans ? genderTransContext[gender] : genderContext[gender];
}
